<template>
    <!-- 开关二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <index-form-item :labelText="labelName"
                   :labelWidth="labelWidth"
                   :labelPosition="labelPosition"
                   :textAlign="labelTextPosition"
                   :formType="formType"
                   :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-time-picker align="right"
                      arrow-control
                      :placeholder="placeholder"
                      :readonly="isReadonly"
                      :disabled="isDisabled"
                      :editable="isEditable"
                      :clearable="isClearable"
                      :style="{ width }">
      </el-time-picker>
    </div>
  </index-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixFormItemTemplateChild 表单项子级混入
 */
import { mixFormItemTemplateChild } from "@/mixins/form_item/mix_form_item_template_child.js";


export default {
  mixins: [ mixFormItemTemplateChild ]
}
</script>


// WEBPACK FOOTER //
// src/components/form_item/FormItemTimePicker.vue